module.exports = __webpack_public_path__ + "static/media/15.6c4373b8.JPG";